import { LoanData } from '@/interfaces/loan';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  state: {
    data: {} as LoanData,
    recurringPaymentDetail: null
  },
  actions,
  getters,
  mutations,
};
